import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import TopBar from '../Home/TopBar';
import { useUserContext } from '../../context/UserContext';
import { useSearchParams } from '../../context/SearchParamsContext';
import { Link, useHistory, useParams } from 'react-router-dom';
import qs from 'qs';
import Button from '../../components/Button';
import { FiDownload } from 'react-icons/fi';
import { AlertIcon } from '../../components/icons';
import InvoiceDetails from './InvoiceDetails';
import axios from 'axios';
import { IndividualSearch, InvoiceInfo, OrderBillingDoc, Property } from './types';
import { convertToFileDownload } from '../../components/utilities/fileUtilities';
import { Loader } from 'semantic-ui-react';

const Wrapper = styled.div`
  padding: 80px 200px;
`;
const WarningWrapper = styled.div`
  background-color: #fffcf5;
  border: 1px solid #f9f4ea;
  border-radius: 5px;
  display: flex;
  align-items: center;
  color: #968d7a;
  height: 72px;
  padding-left: 26px;
  margin-top: 16px;
  margin-bottom: 32px;
`;
const Header = styled.div`
  background-color: #f7f7f9;
  color: #8e8e93;
  display: grid;
  grid-template-columns: 60% 10% 10% 10% 10%;
  grid-column-gap: 1%;
  padding: 8px 24px;
`;
const Total = styled.div`
  display: grid;
  grid-template-columns: 71% 10% 10% 10%;
  grid-column-gap: 1%;
  padding: 16px 24px;
  border-top: 1px solid #e5e5ea;
`;
const InnerWrapper = styled.div`
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  padding: 8px 24px 24px 24px;
`;
const InvoicePage = () => {
  const [invoiceDetails, setInvoiceDetails] = useState<InvoiceInfo[]>([]);
  const [generating, setGenerating] = useState<boolean>(false);
  const { user } = useUserContext();
  const searchParams = useSearchParams();
  const { orderId, titleNumber } = useParams<{ orderId: string; titleNumber: string }>();
  const history = useHistory();
  const headerSearch = () => {
    const queryString = qs.stringify({
      open: searchParams.isTopSearchOpen ? 1 : 0,
      query: searchParams.topSearchText,
    });
    document.title = '';
    history.push(`/home?${queryString}`);
  };

  const closeDetailsSearch = () => {
    searchParams.setTopSearchText('');
    searchParams.setIsTopSearchOpen(false);
  };

  const createIndividualSearchFromInvoiceInfo = (invoiceInfo: InvoiceInfo) => {
    return {
      feeType: invoiceInfo.feeType,
      price: invoiceInfo.price,
      quantity: invoiceInfo.quantity,
      rate: invoiceInfo.rate,
      townFee: invoiceInfo.townFee,
      searches: invoiceInfo.searches,
    };
  };

  const formatInvoiceData = (apiInvoiceData: InvoiceInfo[]) => {
    const formattedData = apiInvoiceData.reduce((pre, cur) => {
      if (pre[cur.propertyId]) {
        pre[cur.propertyId].displaySearches.push(createIndividualSearchFromInvoiceInfo(cur));
      } else {
        pre[cur.propertyId] = { ...cur, displaySearches: [createIndividualSearchFromInvoiceInfo(cur)] };
      }
      return pre;
    }, {} as { [key: string]: InvoiceInfo });
    return Object.values(formattedData);
  };

  const getInvoiceDetails = async () => {
    const queryString = qs.stringify({ orderId });
    const { data } = await axios.get<InvoiceInfo[]>(`/api/clientorder/GetOrderBilling?${queryString}`);
    setInvoiceDetails(formatInvoiceData(data));
  };

  const generateBillingDoc = async () => {
    setGenerating(true);
    const { data } = await axios.post(`/api/clientorder/createBillingDoc/${orderId}`);
    convertToFileDownload(data.fileBase64, data.fileName);
    setGenerating(false);
  };

  const getTotalPrice = (data: IndividualSearch[], column: keyof IndividualSearch) => {
    return data.reduce((a, b)=> a + +b[column], 0)
  }
  useEffect(() => {
    getInvoiceDetails();
  }, []);
  return (
    <>
      <TopBar
        search={headerSearch}
        searchText={searchParams.topSearchText}
        onSearchTextChange={searchParams.setTopSearchText}
        setSearchOpen={searchParams.setIsTopSearchOpen}
        searchOpen={searchParams.isTopSearchOpen}
        info
        name={user.clientName}
        closeSearch={closeDetailsSearch}
        isTitleNumber
        titleNumber={titleNumber}
        orderId={+orderId as number}
      />
      <Wrapper>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ fontSize: 32, fontWeight: 700 }}>
            Billing Statement -  <Link to={`/order/${orderId}`}>{titleNumber}</Link>
          </div>
          <Button
            onClick={(e: MouseEvent) => {
              generateBillingDoc();
              e.stopPropagation();
            }}
            buttonText="Download"
            loadingStatus={generating}
            icon={generating ? <div /> : <FiDownload />}
          />
        </div>
        <WarningWrapper>
          <AlertIcon />
          <span style={{ paddingLeft: 16, color: 'black' }}>
            This statement may not be final and does not replace our regular invoice
          </span>
        </WarningWrapper>
        <InnerWrapper>
          {invoiceDetails.map(id => {
            const totalTownFee = getTotalPrice(id.displaySearches, 'townFee');
            const subtotal = getTotalPrice(id.displaySearches, 'price');
            return (
              <>
                <div style={{ fontWeight: 'bold', fontSize: 20, margin: '24px 0' }}>{id.address}</div>
                <div style={{ border: '1px solid #E5E5EA', borderRadius: 6 }}>
                  <Header>
                    <div>Details</div>
                    <div>Qty</div>
                    <div>Price</div>
                    <div>Fee</div>
                    <div>Total</div>
                  </Header>
                  {id.displaySearches.map((search, i) => {
                    return <InvoiceDetails invoiceDetails={search} />;
                  })}
                  <Total>
                   <div>Subtotal</div> 
                   <div>${subtotal}</div>
                   <div>${totalTownFee}</div>
                   <div>${subtotal + totalTownFee}</div>
                    </Total>
                </div>
              </>
            );
          })}
        </InnerWrapper>
      </Wrapper>
    </>
  );
};

export default InvoicePage;
